import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { ProgressCheckPdfFragment } from "./ProgressCheckPdfFragment.ts";

export const GetAllProgressCheckPdfsQuery = graphql(`
  query getAllProgressCheckPdfs {
    getAllProgressCheckPdfs {
      ...ProgressCheckPdf
    }
  }
`);

export function useAllProgressCheckPdfs() {
  const { data, loading, refetch } = useQuery(GetAllProgressCheckPdfsQuery, {
    fetchPolicy: "cache-and-network",
  });

  return {
    pdfs: getFragmentData(
      ProgressCheckPdfFragment,
      data?.getAllProgressCheckPdfs ?? [],
    ),
    loading,
    refetch,
  };
}
